import { TrimLine, TrimLinesDetail, VehicleModel } from '../../utils/interfaces';
/**
 * A class as interface to vehicle data error used in 
 * the alarm service.
 */
 export class VehicleDataAlarm {
    public model: MatchErrorInterface; 
    public year: MatchErrorInterface;
    public version: MatchErrorInterface;

    constructor(model: MatchErrorInterface, year: MatchErrorInterface, version: MatchErrorInterface) {
        this.model = model;
        this.year = year;
        this.version = version;
    }
}

/**
 * The interface to the body-data to the match error service.
 */
export interface MatchDataAlarmBody {
    brand: string;
    vehicleModel: VehicleDataAlarm;
}

/**
 * A class as interface to match-error of the vehicle data.
 */
export class MatchErrorInterface {
    public value: string;
    public similar: Array<string>;
    public match: boolean;

    constructor(value: string, match: boolean, similar: Array<string>) {
        this.match = match;
        this.similar = similar;
        this.value = value;
    }
}

/**
 * Arguments for the compose function used in the error-util-class.
 */
export interface ComposeArgs {
    data: Array<VehicleModel | TrimLine | TrimLinesDetail>; 
    find: string;
    prop: string;
}

/**
 * The interface for selector errors.
 */
export interface SelectorErrors {
    error: string;
    selector?: string;
    method?: string;
    brand?: string;
}
